import { createFileRoute } from '@tanstack/react-router';

import { requireAuthenticatedBeforeLoad } from '~/routing/require-authenticated-before-load.ts';

export const Route = createFileRoute('/screener')({
	beforeLoad: requireAuthenticatedBeforeLoad,
	component: ScreenerPage,
	head: () => ({
		meta: [{ title: 'Screener' }],
	}),
});

function ScreenerPage() {
	return <div className="flex flex-col justify-center"></div>;
}
